import { LibraryRoutes } from '@library/library-routes.mock';

import { AdminRoutes } from '../components/admin/admin.routes.mock';

import { MockPath } from '@library/common/http/mock-path.mock';
import { MaintenanceRoutes } from '@ap/components/maintenance/maintenance-routes.mock';

/* Order matters for the routes, first match is returned, match is RegExp based */
export const Routes: MockPath<unknown>[] = [
   // App specific
   ...AdminRoutes,

   ...LibraryRoutes,
   ...MaintenanceRoutes,
];
